import { ApiService } from './api';

// API service instance
const apiService = ApiService.getInstance();

export interface Area {
    nome: string;
    area_id: string;
    status: string;
}

export interface AreaNotaHistoricoResponse {
    area: string;
    anos: Array<{
        ano: number;
        nota: number;
        variacao: number;
        percentual_variacao: number;
    }>;
    area_id: string;
}

export const areaService = {
    // Get available areas for the current entity
    async getAvailableAreas(entityId: string): Promise<Area[]> {
        try {
            // Fetch data from the backend API
            const response: Area[] = await apiService.get(`/area/${entityId}/usuario`);

            // Transform backend response to Area format
            const areas: Area[] = response.map((item) => ({
                area_id: item.area_id,
                nome: item.nome,
                status: item.status
            }));

            return areas;
        } catch (error) {
            console.error('Error fetching areas from API:', error);
            throw error;
        }
    },

    async getAreaNotaHistorico(entidadeId: string, areaId: string): Promise<AreaNotaHistoricoResponse> {
        try {
            const response: AreaNotaHistoricoResponse = await apiService.get(`/area/${entidadeId}/${areaId}/historico`);
            return response;
        } catch (error) {
            console.error('Error fetching area historical data from API:', error);
            throw error;
        }
    },

    async getAreas(): Promise<Area[]> {
        try {
            const response: Area[] = await apiService.get('/area');
            return response.map((item) => ({
                area_id: item.area_id,
                nome: item.nome,
                status: item.status
            }));
        } catch (error) {
            console.error('Error fetching areas from API:', error);
            throw error;
        }
    },

}; 